<script setup lang="ts">
const route = useRoute()

const { data: page } = await useAsyncData(
  () => `legal:${route.path}`,
  () => queryCollection('legal').path(route.path).first(),
)
useSeoMeta({
  title: () => page.value?.title,
  description: () => page.value?.description,
  ogTitle: () => page.value?.title,
  ogDescription: () => page.value?.description,
})
</script>

<template>
  <main
    class="prose mx-auto min-h-dvh overflow-y-auto px-8 pb-8 pt-32 dark:prose-invert"
  >
    <ContentRenderer v-if="page" :value="page" />
  </main>
</template>
